import React, { useState } from "react";
import { Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react";
import { IoChevronDownCircleOutline } from "react-icons/io5";
import { getSavedLanguage, setLanguage } from "../../helpers/LanguageHelper";
import { COLORS } from "../../utils/Colors";
const languages = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "ar", label: "العربية" },
];

const LanguageSwitcher: React.FC = () => {
  const [currentLang, setCurrentLang] = useState(getSavedLanguage());
  const [open, setOpen] = useState(false);

  const handleSelect = (code: string) => {
    setCurrentLang(code);
    setLanguage(code);
    setOpen(false);
  };

  const currentLabel = languages
    .find((l) => l.code === currentLang)
    ?.code.toLocaleUpperCase();

  return (
    <Menu>
      <MenuButton
        bg="transparent"
        as={Button}
        _active={{ bg: "transparent" }}
        _hover={{ bg: "transparent" }}
        leftIcon={<IoChevronDownCircleOutline color={COLORS.Neutral.Gray} />}
      >
        <span style={{ color: COLORS.Neutral.Gray }}>{currentLabel}</span>
      </MenuButton>
      <MenuList width={"100px"}>
        {languages.map((l) => (
          <MenuItem
            key={l.code}
            onClick={() => handleSelect(l.code)}
            _hover={{ bg: "transparent" }}
          >
            {l.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LanguageSwitcher;
